














































import Vue from 'vue'
import Component, {mixins} from 'vue-class-component'
import {Action, State} from 'vuex-class'
import Carrier from '@/modules/shipping/model/Carrier'
import CarrierDetail from '@/modules/shipping/components/CarrierDetail.vue';
import {Colors, notify} from '@/modules/core/notification';
import {DateMixin} from '@/modules/core/date';

/**
 * Lista de transportistas
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {CarrierDetail},
})
export default class CarrierList extends mixins(DateMixin) {
    @State(state => state.shipping.currentCarrier)
    public carrier: Carrier

    @State(state => state.shipping.carriers)
    public carriers: Carrier[]

    @Action('shipping/loadCarrierList')
    public loadCarrierList: () => void

    /**
     * Controla la visibilidad de la pantalla para editar un transportista
     */
    public carrierDetail = false
    public deleteConfirm = false
    public deleting = false

    public created () {
        this.loadCarrierList()
    }

    /**
     * Activa la pantalla de edición del transportista con la entidad seleccionada
     * por el usuario
     *
     * @param carrier
     */
    public editCarrier (carrier: Carrier) {
        this.$store.dispatch('shipping/loadCarrier', carrier)
        this.carrierDetail = true
    }

    public createCarrier () {
        this.$store.dispatch('shipping/buildNewCarrier')
        this.carrierDetail = true
    }

    public activeCarrierDelete (carrier: Carrier) {
        this.$store.commit('shipping/SET_CURRENT_CARRIER', carrier)
        this.deleteConfirm = true
    }

    public async deleteCarrier () {
        this.deleting = true
        await this.$store.dispatch('shipping/deleteCarrier')

        this.deleteConfirm = false
        this.deleting = false
    }

    public errorCaptured (error: Error) {
        this.deleting = false
        this.deleteConfirm = false
        notify(error.message, Colors.Error)
    }
}
